import { storeSidebarExpanded } from '../../../../shared/consts/MenuLayout.const'
import { useAppDispatch, useAppSelector } from '../../../store/hooks/Redux'
import { selectSidebarExpanded, setSidebarExpanded } from '../../../store/reducers/AppSlice'

/**
 * Состояние сайдбара нужно не только ему самому: от его ширины отступают элементы
 * поверх контента, поэтому держим его в сторе, а выбор пользователя — в localStorage
 */
export const useSidebarExpanded = () => {
  const dispatch = useAppDispatch()
  const expanded = useAppSelector(selectSidebarExpanded)

  const toggleSidebar = () => {
    storeSidebarExpanded(!expanded)
    dispatch(setSidebarExpanded(!expanded))
  }

  return { expanded, toggleSidebar }
}
